import type { SVGProps } from "react";
import { Icon, type IconProps } from "../Icon";
const InternalSvg = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    stroke="currentColor"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={13.333}
      strokeWidth={1.2}
      d="m12.146 14.12 2.66-.348c.329-.046.53.328.332.59l-1.27 1.74a1.55 1.55 0 0 1-1.002.584l-5.243.697 4.833 1.914c.85.343 1.814.337 2.691-.002l4.747-2.012"
    />
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={13.333}
      strokeWidth={1.2}
      d="M19.89 12.71c-.81-.332-6.497-2.51-8.572-.692-.828.729-.367 2.15.732 2.104.037-.009.067-.006.104-.014l2.66-.348c.328-.046.53.329.331.59l-1.27 1.742a1.52 1.52 0 0 1-1.002.582l-5.984.8a1.18 1.18 0 0 1-1.334-1.065S1.226 3.489 8.313 3.944c4.741.31 3.194 5.612 3.194 5.612s1.275-3.202 4.33-1.878c2.615 1.152 2.216 3.721 2.216 3.721"
    />
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={13.333}
      strokeWidth={1.2}
      d="m15.145 14.35-1.27 1.742a1.52 1.52 0 0 1-1.002.582l-5.984.8a1.18 1.18 0 0 1-1.334-1.065S1.226 3.489 8.313 3.944c4.741.31 3.194 5.612 3.194 5.612s1.275-3.202 4.33-1.878c2.615 1.152 2.216 3.721 2.216 3.721"
      style={{
        stroke: "var(--icon-accent,#E47B53)",
      }}
    />
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={13.333}
      strokeWidth={1.2}
      d="M19.89 12.71c-.81-.332-6.498-2.51-8.572-.692-.828.729-.368 2.15.732 2.104.037-.009.067-.006.104-.014l2.66-.348c.328-.046.53.329.331.59"
    />
  </svg>
);
export const GiveHeartIcon = (props: IconProps) => (
  <Icon {...props} Icon={InternalSvg} />
);
